import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import StructuredData from "@/components/feature/StructuredData";
import {
  buildBreadcrumbSchema,
  buildRouteBreadcrumbs,
  buildWebSiteSchema,
} from "@/utils/schemaBuilders";

/**
 * Site-wide JSON-LD structured data, mounted once inside SiteLayout.
 *
 * - Always emits the WebSite schema (site identity for Google).
 * - Emits a BreadcrumbList for the current route when it is a simple top-level
 *   page. Pages that already render their own, more specific breadcrumb
 *   (service detail + areas-we-serve) are skipped so nothing is duplicated.
 */
export default function SiteSchema() {
  const { pathname } = useLocation();

  const websiteSchema = useMemo(() => buildWebSiteSchema(), []);
  const breadcrumbSchema = useMemo(() => {
    const crumbs = buildRouteBreadcrumbs(pathname);
    return crumbs.length > 1 ? buildBreadcrumbSchema(crumbs) : null;
  }, [pathname]);

  return (
    <>
      <StructuredData id="ld-website" data={websiteSchema} />
      {breadcrumbSchema && <StructuredData id="ld-route-breadcrumb" data={breadcrumbSchema} />}
    </>
  );
}